import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const RECONCILE_CORE_FIELDS = gql`
  fragment ReconcileCoreFields on Reconcile {
    id
    startOn
    endOn
    startBalance
    endBalance
    completedAt
    serviceChargeAmount
    serviceChargeDate
    serviceChargeAccount { id }
    interestAmount
    interestDate
    interestAccount { id }
  }
`;

export const RECONCILE_FIELDS = gql`
  ${RECONCILE_CORE_FIELDS}
  fragment ReconcileFields on Reconcile {
    ...ReconcileCoreFields
    account {
      id
      fullName
    }
  }
`;

export const RECONCILE = gql`
  ${RECONCILE_FIELDS}
  query Reconcile($id: ID!) {
    reconcile(id: $id) {
      ...ReconcileFields
    }
  }
`;

export const RECONCILES = gql`
  ${RECONCILE_FIELDS}
  query Reconciles {
    reconciles {
      ...ReconcileFields
    }
    accounts {
      value: id
      label: fullName
    }
  }
`;

const RECONCILE_ARGUMENTS = `
  $accountId: ID!
  $startOn: ISO8601Date!
  $endOn: ISO8601Date!
  $startBalance: Decimal!
  $endBalance: Decimal!
  $completedAt: ISO8601DateTime
  $serviceChargeAmount: Decimal
  $serviceChargeDate: ISO8601Date
  $serviceChargeAccountId: ID
  $interestAmount: Decimal
  $interestDate: ISO8601Date
  $interestAccountId: ID
`;

const RECONCILE_VARIABLES = `
  accountId: $accountId
  startOn: $startOn
  endOn: $endOn
  startBalance: $startBalance
  endBalance: $endBalance
  completedAt: $completedAt
  serviceChargeAmount: $serviceChargeAmount
  serviceChargeDate: $serviceChargeDate
  serviceChargeAccountId: $serviceChargeAccountId
  interestAmount: $interestAmount
  interestDate: $interestDate
  interestAccountId: $interestAccountId
`;

export const CREATE_RECONCILE = gql`
  ${RECONCILE_CORE_FIELDS}
  mutation CreateReconcile (
    ${RECONCILE_ARGUMENTS}
  ) {
    createReconcile (
      ${RECONCILE_VARIABLES}
    ) {
      reconcile {
        ...ReconcileCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_RECONCILE = gql`
  ${RECONCILE_FIELDS}
  mutation UpdateReconcile (
    $id: ID!
    ${RECONCILE_ARGUMENTS}
  ) {
    updateReconcile (
      id: $id
      ${RECONCILE_VARIABLES}
    ) {
      reconcile {
        ...ReconcileFields
      }
      ${ERRORS}
    }
  }
`;

export const RECONCILE_TXN_LINES = gql`
  query ReconcileTxnLines($id: ID!) {
    reconcileTxnLines(id: $id) {
      id
      debitLessCredit
      reconcileId
      txn { id, bankDate, type, method, reference, name }
    }
  }
`;

export const UPDATE_TXN_LINE = gql`
  mutation UpdateTxnLine (
    $id: ID!
    $reconcileId: ID
  ) {
    updateTxnLine(
      id: $id
      reconcileId: $reconcileId
    ) {
      txnLine {
        id
        reconcileId
      }
      ${ERRORS}
    }
  }
`;
